import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
} from '@angular/core';

export enum SpinnerSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Huge = 'huge',
}

export enum SpinnerDirection {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum SpinnerRender {
  Inline = 'inline',
  Block = 'block',
  Fill = 'fill',
}

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  @Input()
  size: SpinnerSize = SpinnerSize.Medium;

  @Input()
  label = '';

  @Input()
  direction = SpinnerDirection.Horizontal;

  @Input()
  render = SpinnerRender.Fill;

  constructor() {}

  ngOnInit() {}
}
